import React, {Component} from 'react';

import { Campaign, CampaignPreviewCard}  from 'dabbl-react-components';
import { hideChatBox } from '../../../shared/utils';


class PreviewCampaign extends Component {
  constructor() {
    super();
    this.state = {isPreviewShown: false, isLoading: true}
  }

  componentWillMount() {
    Promise.resolve()
      .then(() => this.props.getPreviewCampaign(this.props.previewToken))
      .then(campaign => this.setState({isLoading: false, campaign: campaign}))
      .catch(() => this.setState({isLoading: false}))
  }

  componentDidMount(){
    hideChatBox();
  }

  componentDidUpdate(){
    hideChatBox();
  }

  handlePreviewClick() {
    this.setState({isPreviewShown: true})
  }

  handleClose() {
    this.props.history.goBack()
  }

  handleRate() {
    this.props.history.goBack()
  }

  render() {
    const {isPreviewShown, isLoading, campaign} = this.state;
    if (isLoading) {
      return <div> Loading... </div>
    }
    if (!campaign) {
      return <div>Can't load campaign...</div>
    }

    console.log('CAMPAIGN -> ',campaign)

    return (
      <div className='vertical-center PreviewCampaign'>
        <div id='chat-widget'></div>
        {isPreviewShown ? <Campaign campaign={campaign}
                                    onCloseCampaign={() => this.handleClose()}
                                    onRateCampaign={() => this.handleRate()}/>
          : <CampaignPreviewCard brandName={campaign.brandName}
                                 totalValue={campaign.totalValue}
                                 imgSrc={campaign.feedimageurl}
                                 text={campaign.feedtext}
                                 onClick={() => this.handlePreviewClick()}/>
        }
      </div>
    );
  }
}

export default PreviewCampaign;



// WEBPACK FOOTER //
// ./src/routes/PreviewCampaign/components/PreviewCampaign.js